import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { HEADER_ICONS_TYPE } from './constants';
import { getClassNames } from '../../utils';
import Icon from '../Icon';
import withTheme from '../../hocs/withTheme';

type HeaderButtonProps = {
    type?: typeof HEADER_ICONS_TYPE[number];
    to?: string;
    ariaLabel?: string;
    className?: string;
    children?: ReactNode;
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

function HeaderButton({
    type, to, ariaLabel, children, onClick, className = '',
} : HeaderButtonProps) {
    return (
        <React.Fragment>
            {to ? (
                <Link to={to} className="Header__button">
                    {type && <Icon type={type} />}
                    {children && <span>{children}</span>}
                </Link>
            )
                : (
                    <button
                        type="button"
                        name={type}
                        className={getClassNames(className, 'Header__button')}
                        onClick={onClick}
                        aria-label={ariaLabel}
                    >
                        {type && <Icon type={type} />}
                        {children && <span>{children}</span>}
                    </button>
                )}
        </React.Fragment>
    );
}

export default withTheme(HeaderButton);
